
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import NotesModal from '@/components/modals/NotesModal.vue';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: { NotesModal }
	})
	export default class NotesButton extends Vue {
		private toggle = false;

		public text = '';

		private clicked() {
			this.$state.utils.showNotes = true;
		}

		private open() {
			this.text = this.$state._patient.patientUIData.notes;
			this.$state.utils.showNotes = true;
			// this.toggle = true;
		}

		private cancel() {
			this.$state.utils.showNotes = false;
		}

		private async save() {
			this.$state._patient.patientUIData.notes = this.text;
			if (this.$state._patient.userRecordID) await this.$state._patient.updateMedicalProfile();
			this.$state.utils.showNotes = false;
		}
	}
